<!-- <div class="title">{{configData.label}}</div> -->
<div class="notes-box">
    <div class="tabs">
        <div (click)="setTab(0, true)" class="tab" [ngClass]="{ active: $safeNavigationMigration(activeTab?.isAllTab) }">All Notes</div>
        <div *ngFor="let tab of noteTabs; index as i" class="tab" (click)="setTab(i, false)" [ngClass]="{ active: activeTab.name === tab.value }">{{tab.label}}</div>
        <div class="tab"></div>
    </div>
    <div class="main-content">
        <table>
            <thead>
                <th class="stretched">Date & Time</th>
                <th>User</th>
                <th>Note Type</th>
                <th class="fill">Notes</th>
                <th *ngIf="editAccess">Internal Only</th>
            </thead>
            <tr *ngFor="let note of notes" [ngClass]="{ 'highlight': note.internalOnly, 'verification-text': note.noteType === 'verification'}">
                <td>{{note.createdOn | date: 'MM/dd/yyyy HH:mm'}} {{ note.createdOn | date : 'a' | lowercase }}</td>
                <td>{{note.createdBy | stripemail}}</td>
                <td>{{ transformNoteType(note.noteType)  | titlecase}}</td>
                <td>{{note.text}}</td>
                <td *ngIf="editAccess">{{note.internalOnly | yesno}}</td>
            </tr>
        </table>
    </div>
    <div class="divider">
        <div></div>
    </div>
    <div class="new-note">
        <div class="row g-2">
            <div class="col-md-5 px-8 dhl-notes-field">
                <dhl-text-input (input)="disableEmojis($event)" [label]="configData.placeHolder" [text]="currentNoteText" [maxChars]="configData?.maxLength || 500" (textChanged)="currentNoteText = $event; valueChange($event)"></dhl-text-input>
            </div>
            <div class="col-md-2 pr-8 dhl-notes-field">
                <dhl-select-input label="Note Type" [defaultValue]="currentNoteType" [configData]="configData" (selectionChanged)="noteTypeChanged($event,true)"></dhl-select-input>
            </div>
            <div class="col-md-2 pr-8 center-items dhl-notes-field">
                <div class="checkbox-default" *ngIf="isShowDefaultType">
                    <div class="img" style="height: 20px;">
                        <span class="checkbox" [ngClass]="defaultTypeVal ? 'checked' : 'empty'" (click)="selectedOption()"></span>
                    </div>
                    <div class="label">Use As Default Type</div>
                </div>
            </div>
            <div class="col-md-2 pr-8 center-items dhl-notes-field">
                <div *ngIf="editAccess" class="toggle">
                    <div class="label">Internal Only</div>
                    <div class="switch" [ngClass]="{'checked': internalOnly, disabled: internalOnlyDisabled }" (click)="internalOnly = !internalOnly;">
                        <div class="back"></div>
                        <div class="circle"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-1 pr-8 center-items dhl-notes-field">
                <button [ngClass]="{ disabled: (!currentNoteText.length ||  this.disableAddNote) }" [disabled]="(!currentNoteText.length ||  this.disableAddNote)" class="add-note-btn" (click)="addNote()">
                    Add Note
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-5 px-8 dhl-notes-field">
                <span class="count-text">{{counter}} characters remaining</span>
            </div>
        </div>
    </div>
</div>